export class ObjectLabel {
    public __classname__: string = 'ObjectLabel';

    public Id : number | null = null;
	public Name : string | null = null;

    constructor(
        Id : number | null = null, 
        Name: string | null = null
    ) {
        this.Id = Id;
        this.Name = Name;
    }
}